import React from 'react';
import PropTypes from 'prop-types';

import { RideGrid, RideLink, RideGlTelephoneSolid } from '@rimac-seguros/ride-system-components';
import { getTagActionName } from '../../../utils/analytics';

import './styles.scss';

const SectionContact = ({ authoring }) => {
  const {
    title, description, telephone, image,
  } = authoring;

  return (
    <RideGrid className="section-contact">
      <div>
        <div className="section-contact_head">
          <img src={image} alt="Tobi Img" />
          <div className="section-contact_head-text">
            <h3>{title}</h3>
            <p>{description}</p>
          </div>
        </div>
        <div className="section-contact_phone">
          <RideLink
            text={telephone}
            href={`tel:${telephone}`}
            target="_blank"
            variant="secondary"
            glyph={<RideGlTelephoneSolid />}
            glyphPosition="left"
            size="x-large"
            onClick={() => getTagActionName('Seguro Salud Flexible', 'Interacciones', 'Planes', 'Telefono unico', 'trackAction')}
          />
        </div>
      </div>
    </RideGrid>
  );
};

SectionContact.propTypes = {
  authoring: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    telephone: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
  }).isRequired,
};

export default SectionContact;
